/** @jsxImportSource @emotion/react */
import * as UI from "@goodgym/components";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import React from "react";
import { State } from "../../types";

export type CalendarFilterProps = UI.BoxProps & {
  state: Pick<State, "filters">;
};

const CalendarFilter: React.FC<CalendarFilterProps> = ({ state, ...props }) => {

  const initialDate =
    state.filters.values.from
      ? state.filters.values.from
      : null;

  const [selectedDate, setSelectedDate] = React.useState<Date | null>(initialDate);

  const handleChange = (newValue: Date | null) => {
    setSelectedDate(newValue);
    const dateIso =
      newValue && newValue instanceof Date && !isNaN(newValue.getTime())
        ? newValue
        : undefined;
    state.filters.update({ from: dateIso });
    localStorage.setItem("sessionCalendarDate", dateIso?.toISOString() || "");
  };

  return (
    <UI.Box {...props}>
      <UI.Typography variant="subtitle1">
        <UI.Grid container>
          <UI.Grid item sx={{ alignSelf: "center", flexGrow: 1, mb: 1 }}>
            Date
          </UI.Grid>
        </UI.Grid>
      </UI.Typography>

      <UI.Box
        sx={{
          border: "0.1px solid rgba(0, 0, 0, 0.15)" ,
        //   boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          mx: "auto",
          mb:1,
          "& .MuiPickersDay-root": {
            fontSize: "1.15rem",
          },
          "& .Mui-selected": {
            backgroundColor: "primary.main !important",
            color: "white !important",
          },
        }}
      >
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          value={selectedDate}
          minDate={new Date("2010-01-01")}
          maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
          onChange={handleChange}
          renderInput={(params) => <UI.TextField {...params} />}
        />
        <UI.Box sx={{display:"flex", justifyContent:"center", mb:3}}>
         <UI.Button onClick={() => handleChange(new Date())}>
          Today</UI.Button>
        </UI.Box>

      </UI.Box>
    </UI.Box>
  );
};

export default CalendarFilter;
